import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || '';
export const API_BASE = `${BASE}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('th_token');
  if (token) config.headers.Authorization = 'Bearer ' + token;
  return config;
});

// Resolve uploaded media URLs to absolute (prefix /api/uploads/... with backend URL)
export const resolveMedia = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/api/uploads/')) return BASE + url;
  return url;
};

// Convert snake_case keys to camelCase (shallow + nested objects/arrays)
const toCamel = (s) => s.replace(/_([a-z0-9])/g, (_, c) => c.toUpperCase());

export const camelize = (obj) => {
  if (Array.isArray(obj)) return obj.map(camelize);
  if (obj && typeof obj === 'object' && obj.constructor === Object) {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
      out[toCamel(k)] = camelize(v);
    }
    return out;
  }
  return obj;
};

// Convert camelCase to snake_case for outgoing requests when needed
const toSnake = (s) => s.replace(/[A-Z]/g, (c) => '_' + c.toLowerCase());
export const snakeize = (obj) => {
  if (Array.isArray(obj)) return obj.map(snakeize);
  if (obj && typeof obj === 'object' && obj.constructor === Object) {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
      out[toSnake(k)] = snakeize(v);
    }
    return out;
  }
  return obj;
};

// Enrich a property record with derived fields (image, resolved gallery)
export const enrichProperty = (p) => {
  if (!p) return p;
  const c = camelize(p);
  const gallery = (c.gallery || []).map(resolveMedia);
  const videos = (c.videos || []).map(resolveMedia);
  return {
    ...c,
    gallery,
    image: gallery[0] || '',
    videos,
    videoUrl: resolveMedia(c.videoUrl) || videos[0] || '',
  };
};

export const enrichAgent = (a) => {
  if (!a) return a;
  const c = camelize(a);
  return { ...c, photo: resolveMedia(c.photo) };
};

export const enrichBlog = (b) => {
  if (!b) return b;
  const c = camelize(b);
  return { ...c, cover: resolveMedia(c.cover) };
};

export const enrichDeveloper = (d) => {
  if (!d) return d;
  const c = camelize(d);
  return { ...c, logo: resolveMedia(c.logo) };
};

export const enrichTestimonial = (t) => {
  if (!t) return t;
  const c = camelize(t);
  return { ...c, avatar: resolveMedia(c.avatar) };
};

export const enrichSettings = (s) => {
  if (!s) return s;
  const c = camelize(s);
  return { ...c, logo: resolveMedia(c.logo) || '/assets/logo.png', heroImage: resolveMedia(c.heroImage) };
};

export default api;
